<div class="container-fluid px-2 px-md-3 px-xl-1 py-3">
  <div class="d-flex flex-column gap-3">
    <section class="entity-config-top mb-1 rounded-4 overflow-hidden shadow-sm">
      <div class="entity-config-top-hero px-2 px-md-3 py-3">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">Documents Workflow Hub</h1>
            <p class="entity-page-subtitle text-white mb-0 subsystem-subtitle">
              Orchestrate document-specific logic, automated signing requests, and verification triggers within your enterprise ecosystem.
            </p>
          </div>

          <div class="col-auto d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark text-xs d-inline-flex align-items-center rounded-3 px-3 py-2 shadow-sm me-2 align-self-end"
              @click="create_new_workflow"
            >
              <i class="bi bi-plus-circle me-2 text-white"></i>
              Create Workflow
            </button>
          </div>
        </div>
      </div>

      <div class="px-2 px-md-3 pb-3">
        <section class="row g-2 entity-config-top-metrics">
          <div class="col-12 col-md-6 mt-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    Active Workflows
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ active_workflows_count }}</div>
                </div>

                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-diagram-3"></i>
                </div>
              </div>
            </article>
          </div>

          <div class="col-12 col-md-6 mt-2">
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    Pending Signs
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ pending_signs_count }}</div>
                </div>

                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi bi-pen"></i>
                </div>
              </div>
            </article>
          </div>
        </section>
      </div>
    </section>

    <div class="card border-0 shadow-sm rounded-4 overflow-hidden">
      <div class="card-header bg-white border-bottom py-3">
        <div class="d-flex flex-wrap align-items-center justify-content-between gap-2">
          <div class="fw-bold">Configured Workflows</div>
          <div class="d-flex align-items-center gap-2">
            <button type="button" class="btn btn-light btn-sm rounded-3" aria-label="Filter">
              <i class="bi bi-funnel"></i>
            </button>
            <button type="button" class="btn btn-light btn-sm rounded-3" aria-label="Sort">
              <i class="bi bi-sliders"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="card-body p-3 p-md-4">
        <div class="d-flex flex-column gap-3">
          <div
            v-for="workflow in filtered_workflows"
            :key="workflow.id"
            class="card rounded-4 border-0 shadow-sm"
          >
            <div class="card-body p-3 d-flex flex-column flex-lg-row align-items-start justify-content-between gap-3">
              <div class="d-flex align-items-start gap-3 flex-grow-1 overflow-hidden">
                <div
                  class="workflow-card-icon d-inline-flex align-items-center justify-content-center flex-shrink-0 bg-primary-subtle text-primary"
                >
                  <i v-if="workflow.status === 'active'" class="bi bi-shield-check"></i>
                  <i v-else class="bi bi-pencil-square"></i>
                </div>

                <div class="flex-grow-1 overflow-hidden">
                  <div class="d-flex flex-wrap align-items-center gap-2 mb-1">
                    <div class="fw-bold text-x text-truncate">{{ workflow.name }}</div>
                    <span
                      class="badge rounded-pill text-uppercase"
                      :class="workflow.status === 'active' ? 'bg-primary-subtle text-primary' : 'bg-warning-subtle text-warning'"
                    >
                      {{ workflow.status === 'active' ? 'Active' : 'Draft' }}
                    </span>
                  </div>

                  <div class="text-secondary text-xs fw-semibold mb-2">
                    {{ workflow.description }}
                  </div>

                  <div class="d-flex flex-wrap align-items-center gap-3 text-secondary text-xxs fw-semibold">
                    <span class="d-inline-flex align-items-center gap-2">
                      <i class="bi bi-diagram-3"></i>
                      Entity: {{ workflow.entity || '—' }}
                    </span>
                    <span v-if="workflow.last_modified_label" class="d-inline-flex align-items-center gap-2">
                      <i class="bi bi-clock-history"></i>
                      {{ workflow.last_modified_label }}
                    </span>
                    <span v-else-if="workflow.steps_remaining" class="d-inline-flex align-items-center gap-2">
                      <i class="bi bi-list-ol"></i>
                      {{ workflow.steps_remaining }} steps remaining
                    </span>
                    <span v-else-if="workflow.auto_renewal_enabled" class="d-inline-flex align-items-center gap-2">
                      <i class="bi bi-repeat"></i>
                      Auto-renewal enabled
                    </span>
                  </div>
                </div>
              </div>

              <div class="d-flex flex-wrap align-items-center gap-2 flex-shrink-0">
                <button
                  type="button"
                  class="btn btn-link text-primary text-decoration-none fw-bold text-xs d-inline-flex align-items-center gap-2 p-0"
                  @click="edit_workflow(workflow)"
                >
                  <i class="bi bi-pencil"></i>
                  Edit Workflow
                </button>
                <button
                  type="button"
                  class="btn btn-light btn-sm rounded-3 fw-semibold text-xs d-inline-flex align-items-center gap-2"
                  @click="assign_to_entity(workflow)"
                >
                  <i class="bi bi-person-plus"></i>
                  Assign to Entity
                </button>
              </div>
            </div>
          </div>

          <div v-if="!filtered_workflows.length" class="text-center text-secondary text-xs py-5">
            No workflows found.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
